import React from "react";
import { Key } from "../../1/types";
import KeyRow from "./KeyRow";

interface KeysTableProps {
  keys: Key[];
  disabled?: boolean;
  backendUrl: string;
  findKey: (name: string) => Key | undefined;
  handleRemoveKeyx: (id: number) => void;
  handleInputChangeAmont: (index: number, value: number, field: string, step: number) => void;
  header: { supllier?: string; model?: string };
}

const KeysTable: React.FC<KeysTableProps> = ({
  keys,
  disabled,
  backendUrl,
  findKey,
  handleRemoveKeyx,
  handleInputChangeAmont,
  header,
}) => {
  return (
    <div id="special-options-keys" className="specialOptions" style={{ border: "none", borderTop: "none" }}>
      <div style={{ width: "100%" }}>
        <div
          className="keys-table-header"
          style={{
            backgroundColor: "#005CA9",
          textAlign: "center",
          display: "flex",
          justifyContent: "space-between",
          color: "#FFFFFF",
          fontWeight: "bold",
        }}
      >
        <div className="is-size-6">Schlüssel konfigurieren</div>
        <div className="is-size-6 has-text-weight-bold">
          {header.supllier} {header.model}
        </div>
      </div>
      {/* No column headers for keys: keep only section title above */}
      {keys.map((keyObj, index) => (
        <KeyRow
          key={`${keyObj.keyName}-${index}`}
          keyData={keyObj}
          index={index}
          disabled={disabled}
          backendUrl={backendUrl}
          findKey={findKey}
          handleRemoveKeyx={handleRemoveKeyx}
          handleInputChangeAmont={handleInputChangeAmont}
        />
      ))}
      </div>
    </div>
  );
};

export default KeysTable;
